import { apiClient } from './apiClient';

class NationsService {
  constructor() {
    // nutzt apiClient
  }

  // Alle Nationen abrufen
  async getAllNations(filters = {}) {
    try {


      // Query-Parameter für Filter erstellen
      const queryParams = new URLSearchParams();
      if (filters.status) queryParams.append('status', filters.status);
      if (filters.region) queryParams.append('region', filters.region);

      const endpoint = `/nations${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const result = await apiClient.get(endpoint);

      return {
        success: true,
        data: result,
        total: Array.isArray(result) ? result.length : 0
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  }

  // Nation nach Code abrufen
  async getNationByCode(code) {
    try {


      // Suche nach Nation mit diesem Code
      const allNations = await this.getAllNations();
      if (!allNations.success) {
        throw new Error('Fehler beim Laden der Nationen');
      }

      const nation = allNations.data.find(n => n.code === code);

      if (!nation) {
        return {
          success: false,
          error: 'Nation nicht gefunden',
          data: null
        };
      }

      return {
        success: true,
        data: nation
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Nation nach ID abrufen
  async getNationById(id) {
    try {


      const result = await apiClient.get(`/nations/${id}`);

      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Nationen nach Region abrufen
  async getNationsByRegion(region) {
    try {


      const result = await apiClient.get(`/nations/regions/${region}`);

      return {
        success: true,
        data: result,
        total: Array.isArray(result) ? result.length : 0
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  }

  // Nation-Status aktualisieren
  async updateNationStatus(nationId, status) {
    try {


      const result = await apiClient.put(`/nations/${nationId}/status`, { status });

      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Teilnehmerstatistiken abrufen
  async getParticipantStats() {
    try {


      const result = await apiClient.get('/nations/stats/participants');

      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  // Team-Verwaltung
  async getNationTeam(nationId) {
    try {

      const result = await apiClient.get(`/nations/${nationId}/team`);
      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  async updateTeamParticipation(nationId, participatesInTeamCompetition) {
    try {

      const result = await apiClient.put(`/nations/${nationId}/team/participation`, {
        participatesInTeamCompetition
      });
      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  async setTeamMembers(nationId, participantIds) {
    try {

      const result = await apiClient.put(`/nations/${nationId}/team/members`, {
        participantIds
      });
      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: null
      };
    }
  }

  async getAvailableParticipants(nationId) {
    try {

      const result = await apiClient.get(`/nations/${nationId}/team/available-participants`);
      return {
        success: true,
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  }
}

// Singleton-Instanz exportieren
const nationsService = new NationsService();
export default nationsService; 